module.exports = __webpack_public_path__ + "img/about-4.f39824e.jpg";